import React, { useState, useEffect } from 'react'
import { useField } from '@formiz/core'

export const Checkbox = (props) => {
  const {
    errorMessage,
    id,
    isValid,
    isPristine, 
    isSubmitted,
    resetKey,
    setValue,
    value
  } = useField(props)
  const { label, type, required, placeholder } = props
  const [isFocused, setIsFocused] = React.useState(false);
  const showError = !isValid && !isFocused && (!isPristine || isSubmitted)

  return (
    <div>
      <input
        key={resetKey}
        id={id}
        type='checkbox'
        value={value}
        placeholder = {placeholder}
        onChange={e => setValue(e.target.checked)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        aria-invalid={!isValid}
        aria-describedby={!isValid ? `${id}-error` : null}
      />
      <label className="label-checkbox" htmlFor={id}>{ label }{required && ' *'}</label>
      {showError && (
        <div id={`${id}-error`} className="error-feedback">
          { errorMessage }
        </div>
      )}
    </div>
  )
}